import Network from './network';
import { IFilter } from '../types/context';
import { ManagerFeedbackPayload } from '../../view/components/NPS/types';

enum filterPropType {
  Org = 1,
}

//TODO: refactor this function
export const transformFilterKeysToQueryParams = (filters: IFilter) => {
  const selectedFilters: any = {
    // fromDate: '2023-05-01',
    // toDate: '2024-05-01',

    ...filters.dateRange,
  };

  if (filters.benchmarkType) {
    selectedFilters.industryId = filters.benchmarkType;
  }

  const extractSelectedOrganisations = (
    selectedOrganisations: Map<any, boolean>,
  ) => {
    return Array.from(selectedOrganisations.entries())
      .filter(([, isSelected]) => isSelected)
      .map(([id]) => id);
  };

  if (filters.selectedOrganisations.size) {
    const arrayOfOrganisations = extractSelectedOrganisations(
      filters.selectedOrganisations,
    );
    if (arrayOfOrganisations.length) {
      selectedFilters.organisationId = arrayOfOrganisations;
    }
  }
  // selectedFilters.dateRange = { ...filters.dateRange };
  if (filters.ageFilter?.length) {
    selectedFilters.age = filters.ageFilter;
  }

  if (filters.genderFilter?.length) {
    selectedFilters.gender = filters.genderFilter;
  }

  if (filters.selectedDepartments.size) {
    const arrayOfDepartments = Array.from(filters.selectedDepartments.entries())
      .filter(([, isSelected]) => isSelected)
      .map(([id]) => id);

    if (arrayOfDepartments.length) {
      selectedFilters.teamIds = arrayOfDepartments;
    }
  }

  if (filters.selectedOrganisations.size) {
    const arrayOfOrganisations = extractSelectedOrganisations(
      filters.selectedOrganisations,
    );
    if (arrayOfOrganisations.length) {
      selectedFilters.organisationId = arrayOfOrganisations;
    }
  }

  if (filters.regionFilter?.length) {
    selectedFilters.country = filters.regionFilter;
  }

  return selectedFilters;
};

export const getWidgetLayoutV2 = async (slug: string | undefined) => {
  const response = await Network.get({
    url: `${import.meta.env.VITE_API_BASE_URL}splashy/v2/dashboards/${slug}`,
  });

  return response?.data;
};

export const WidgetApi = async (
  widgetId: string,
  filters: IFilter,
  additionalParams?: any,
) => {
  // const additionalParams = {
  //   page: 1,
  //   sort: 'value',
  //   order: 'asc', // or 'desc'
  // };

  const params = {
    ...transformFilterKeysToQueryParams(filters),
    ...additionalParams,
  };
  const response = await Network.get({
    url: `${
      import.meta.env.VITE_API_BASE_URL
    }splashy/v2/dashboards/widgets/${widgetId}`,
    params,
  });
  return response?.data;
};

export const WidgetApiV2 = async (
  widgetId: string,
  filters: IFilter,
  additionalQueries?: Record<string, unknown>,
) => {
  const queryParams = {
    ...transformFilterKeysToQueryParams(filters),
    ...additionalQueries,
  };

  const response = await Network.get({
    url: `${
      import.meta.env.VITE_API_BASE_URL
    }splashy/v2/dashboards/widgets/${widgetId}`,
    params: queryParams,
  });
  return response?.data;
};

let memberScopePrefetchKey: string | undefined;
let memberScopePrefetchPromise: Promise<unknown> | undefined;

export const prefetchMemberScope = (filters: IFilter) => {
  const params = transformFilterKeysToQueryParams(filters);
  const key = JSON.stringify(params);

  if (key !== memberScopePrefetchKey) {
    memberScopePrefetchKey = key;
    memberScopePrefetchPromise = Network.get({
      url: `${
        import.meta.env.VITE_API_BASE_URL
      }splashy/v2/dashboards/widgets/prefetch`,
      params,
    }).catch(() => undefined);
  }

  return memberScopePrefetchPromise;
};

export const submitManagerFeedback = async (data: ManagerFeedbackPayload) => {
  return await Network.post({
    url: `${import.meta.env.VITE_API_BASE_URL}splashy/v2/dashboards/feedback`,
    body: {
      feedback: data,
    },
  });
};
